import { createSlice } from '@reduxjs/toolkit';

export const pathSlice = createSlice({
  name: 'path',
  initialState: '',
  reducers: {},
});

export const { reducer: pathReducer } = pathSlice;
